/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Health_DeniedInputs */

const en_us2_native_release_health_denied = /** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Health Connect did not grant access, so nothing was switched on.`)
};

const pt_br2_native_release_health_denied = /** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Health Connect não deu permissão, então nada foi ligado.`)
};

const pt_pt2_native_release_health_denied = /** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Health Connect não deu permissão, então nada foi ligado.`)
};

/** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */
const es_419_native_release_health_denied = en_us2_native_release_health_denied;

/** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */
const fr_fr2_native_release_health_denied = en_us2_native_release_health_denied;

/** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */
const de_de2_native_release_health_denied = en_us2_native_release_health_denied;

/** @type {(inputs: Native_Release_Health_DeniedInputs) => LocalizedString} */
const it_it2_native_release_health_denied = en_us2_native_release_health_denied;

/**
* | output |
* | --- |
* | "Health Connect did not grant access, so nothing was switched on." |
*
* @param {Native_Release_Health_DeniedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_health_denied = /** @type {((inputs?: Native_Release_Health_DeniedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Health_DeniedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_health_denied(inputs)
	if (locale === "es-419") return es_419_native_release_health_denied(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_health_denied(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_health_denied(inputs)
	if (locale === "de-DE") return de_de2_native_release_health_denied(inputs)
	if (locale === "it-IT") return it_it2_native_release_health_denied(inputs)
	return en_us2_native_release_health_denied(inputs)
});
export { native_release_health_denied as "native-release.health_denied" }